import React from 'react';
import {useLocation} from 'react-router-dom';

import ErrorBoundary from './ErrorBoundary';

const ErrorBoundaryWrapper = ({children}: {children: React.ReactNode}) => {
    const location = useLocation();

    // Key on the error boundary resets the error when the url changes.
    return <ErrorBoundary key={location.pathname}>{children}</ErrorBoundary>;
};

export default ErrorBoundaryWrapper;
